import { cva } from 'class-variance-authority';

export const modalBackdropClasses = cva(
  'bg-charcoal-alpha-400 fixed top-0 right-0 bottom-0 left-0 z-[var(--z-backdrop)] flex items-center justify-center'
);

export const modalWrapperClasses = cva(
  [
    'bg-beige-50 absolute top-0 right-0 bottom-0 left-0 z-[var(--z-modal)] m-auto flex flex-col overflow-hidden border-1 border-solid',
    'lg:max-h-[780px] lg:max-w-[720px] lg:rounded-2xl lg:shadow-[0px_4px_24px_rgba(0,0,0,0.475)]'
  ],
  {
    variants: {
      borderless: {
        true: 'border-transparent',
        false: 'border-charcoal-alpha-50'
      }
    },
    defaultVariants: {
      borderless: false
    }
  }
);

export const modalHeaderClasses = cva([
  'border-charcoal-alpha-50 bg-sandstone-light flex flex-none flex-row items-start justify-between gap-1 border-1 border-b-1 border-solid px-4 py-3 lg:p-6'
]);

export const modalContentWrapperStyles = cva([
  'bg-sandstone-dark flex flex-1 flex-col overflow-y-auto'
]);

export const modalContentStyles = cva(['mx-4 my-6 flex flex-1 flex-col', 'lg:m-6']);

export const modalFooterClasses = cva([
  'border-charcoal-alpha-50 bg-sandstone-light flex flex-row justify-between gap-3 border-t-1 border-solid p-4',
  'lg:flex-row lg:p-6'
]);
